import React from 'react';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import './Contacts.styles.scss';
import './Contacts.styles.responsive.scss';

const ContactsRouter: React.FC = () => {
  const classes = classNames('contacts-router');

  return (
    <div className={classes}>
      <Outlet />
    </div>
  );
};

export default ContactsRouter;
